export default __webpack_public_path__ + "static/pro@mob_2x-8611ba50be20e391925107c1c59b2128.webp";